
import React from 'react';
import { Pagination } from '@mui/material';
import styles from './Pagination.module.scss'

interface IProps {
    count: number,
    page: number,
    handleChange: any,
    isPagination: boolean

}




const PaginationUI = (props: IProps) => {
    const { count, page, handleChange, isPagination } = props
    return (
        isPagination ? <Pagination
            page={page}
            count={count}
            onChange={handleChange}
            size="large"
            className={styles.Pagination}
        /> : null

    )
}


export default PaginationUI;

